import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Injectable()
export class MetaTagService {
  constructor(
    private titleService: Title,
    private metaService: Meta
  ) {}

  updateMetaTags(metaObject) {
    console.log(metaObject);
    if (metaObject.pageTitle) {
      this.updatePageTitle(metaObject.pageTitle);
    }
    if (metaObject.description) {
      this.updateMetaDescriptions(metaObject.description);
    }
    if (metaObject.image) {
      this.updateMetaImages(metaObject.image);
    }
    if (metaObject.title) {
      this.updateMetaTitles(metaObject.title);
    }
    if (metaObject.url) {
      this.updateMetaUrls(metaObject.url);
    }
  }

  updatePageTitle(newText) {
    this.titleService.setTitle('SupplyHub.com: ' + newText);
  }

  updateMetaDescriptions(newText) {
    this.metaService.updateTag(
      { content: 'SupplyHub.com: ' + newText },
      'name="description"'
    );
    this.metaService.updateTag(
      { content: 'SupplyHub.com: ' + newText },
      'name="summary"'
    );
    this.metaService.updateTag(
      { content: 'SupplyHub.com: ' + newText },
      'property="og:description"'
    );
    this.metaService.updateTag(
      { content: 'SupplyHub.com: ' + newText },
      'name="twitter:description"'
    );
    this.metaService.updateTag(
      { content: 'SupplyHub.com: ' + newText },
      'itemprop="description"'
    );
  }

  updateMetaImages(newText) {
    this.metaService.updateTag(
      { content: newText },
      'property="og:image"'
    );
    this.metaService.updateTag(
      { content: newText },
      'name="twitter:image"'
    );
    this.metaService.updateTag(
      { content: newText },
      'itemprop="image"'
    );
  }

  updateMetaTitles(newText) {
    this.metaService.updateTag(
      { content: 'SupplyHub.com: ' + newText },
      'property="og:title"'
    );
    this.metaService.updateTag(
      { content: 'SupplyHub.com: ' + newText },
      'name="twitter:title"'
    );
    this.metaService.updateTag(
      { content: 'SupplyHub.com: ' + newText },
      'itemprop="name"'
    );
    this.metaService.updateTag(
      { content: 'SupplyHub.com: ' + newText },
      'name="apple-mobile-web-app-title"'
    );
  }

  updateMetaUrls(newText) {
    this.metaService.updateTag(
      { content: 'https://www.supplyhub.com' + newText },
      'name="url"'
    );
    this.metaService.updateTag(
      { content: 'https://www.supplyhub.com' + newText },
      'property="og:url"'
    );
    this.metaService.updateTag(
      { content: 'https://www.supplyhub.com' + newText },
      'name="twitter:url"'
    );
  }
}



// WEBPACK FOOTER //
// /Users/iangoldfarb/Desktop/SupplyHub/shFrontEnd/src/app/services/meta-tag.service.ts